import React from "react";
import { FormattedMessage } from "react-intl";

import { Title, Cancel } from "../Form";
import Modal from "../Modal";

import messages from "./messages";
import { IProps } from "./interfaces";

const NotFound = ({ close }: IProps) => (
    <Modal close={close}>
        <Title>
            <FormattedMessage {...messages.title} />
        </Title>
        <p>
            <FormattedMessage {...messages.p} />
        </p>
        <Cancel onClick={close}>
            <FormattedMessage {...messages.back} />
        </Cancel>
    </Modal>
);

export default NotFound;
